// import React from 'react';

const statistic = [
  {
    year: '1991',
    appeals: 0,
    trip: 17,
    rescued: 3,
    trained: 0,
    id: 1,
  },
  {
    year: '1992',
    appeals: 0,
    trip: 57,
    rescued: 12,
    trained: 0,
    id: 2,
  },
  {
    year: '1993',
    appeals: 0,
    trip: 42,
    rescued: 9,
    trained: 0,
    id: 3,
  },
  {
    year: '1994',
    appeals: 0,
    trip: 56,
    rescued: 17,
    trained: 0,
    id: 4,
  },
  {
    year: '1995',
    appeals: 0,
    trip: 27,
    rescued: 8,
    trained: 0,
    id: 5,
  },
  {
    year: '1996',
    appeals: 0,
    trip: 39,
    rescued: 11,
    trained: 0,
    id: 6,
  },
  {
    year: '1997',
    appeals: 0,
    trip: 56,
    rescued: 13,
    trained: 0,
    id: 7,
  },
  {
    year: '1998',
    appeals: 0,
    trip: 112,
    rescued: 18,
    trained: 0,
    id: 8,
  },
  {
    year: '1999',
    appeals: 0,
    trip: 180,
    rescued: 21,
    trained: 0,
    id: 9,
  },
  {
    year: '2000',
    appeals: 0,
    trip: 217,
    rescued: 23,
    trained: 0,
    id: 10,
  },
  {
    year: '2001',
    appeals: 0,
    trip: 845,
    rescued: 26,
    trained: 0,
    id: 11,
  },
  {
    year: '2002',
    appeals: 0,
    trip: 1462,
    rescued: 56,
    trained: 0,
    id: 12,
  },
  {
    year: '2003',
    appeals: 0,
    trip: 1670,
    rescued: 72,
    trained: 0,
    id: 13,
  },
  {
    year: '2004',
    appeals: 16867,
    trip: 1169,
    rescued: 60,
    trained: 0,
    id: 14,
  },
  {
    year: '2005',
    appeals: 13621,
    trip: 1252,
    rescued: 64,
    trained: 0,
    id: 15,
  },
  {
    year: '2006',
    appeals: 14878,
    trip: 1211,
    rescued: 184,
    trained: 0,
    id: 16,
  },
  {
    year: '2007',
    appeals: 13117,
    trip: 1398,
    rescued: 233,
    trained: 0,
    id: 17,
  },
  {
    year: '2008',
    appeals: 16569,
    trip: 2211,
    rescued: 293,
    trained: 0,
    id: 18,
  },
  {
    year: '2009',
    appeals: 16578,
    trip: 2071,
    rescued: 319,
    trained: 0,
    id: 19,
  },
  {
    year: '2010',
    appeals: 21528,
    trip: 2116,
    rescued: 263,
    trained: 0,
    id: 20,
  },
  {
    year: '2011',
    appeals: 21892,
    trip: 1976,
    rescued: 223,
    trained: 479,
    id: 21,
  },
  {
    year: '2012',
    appeals: 21455,
    trip: 1915,
    rescued: 212,
    trained: 521,
    id: 22,
  },
  {
    year: '2013',
    appeals: 19618,
    trip: 1915,
    rescued: 243,
    trained: 339,
    id: 23,
  },
  {
    year: '2014',
    appeals: 18698,
    trip: 2108,
    rescued: 227,
    trained: 338,
    id: 24,
  },
  {
    year: '2015',
    appeals: 16730,
    trip: 1888,
    rescued: 193,
    trained: 484,
    id: 25,
  },
  {
    year: '2016',
    appeals: 16973,
    trip: 1955,
    rescued: 195,
    trained: 393,
    id: 26,
  },
  {
    year: '2017',
    appeals: 15538,
    trip: 1864,
    rescued: 184,
    trained: 387,
    id: 27,
  },
  {
    year: '2018',
    appeals: 16208,
    trip: 2085,
    rescued: 193,
    trained: 593,
    id: 28,
  },
  {
    year: '2019',
    appeals: 14130,
    trip: 1685,
    rescued: 206,
    trained: 688,
    id: 29,
  },
  {
    year: '2020',
    appeals: 13843,
    trip: 1710,
    rescued: 198,
    trained: 463,
    id: 30,
  },
  {
    year: '2021',
    appeals: 14679,
    trip: 1955,
    rescued: 206,
    trained: 513,
    id: 31,
  },
  {
    year: '2022',
    appeals: 13720,
    trip: 1865,
    rescued: 203,
    trained: 658,
    id: 32,
  },
  {
    year: '2023',
    appeals: 12047,
    trip: 1745,
    rescued: 164,
    trained: 788,
    id: 33,
  },
  {
    year: '2024',
    appeals: 11640,
    trip: 1771,
    rescued: 169,
    trained: 503,
    id: 34,
  },
  {
    year: '2025',
    appeals: 10146,
    trip: 1463,
    rescued: 150,
    trained: 602,
    id: 35,
  },
];

export default statistic;
